export const SUMMARY_STATEMENTS = [
  'IsGoodRelativeValue',
  'IsTradingBelowAnalystPriceTargets',
] as const;
